import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {deviceTypeActions} from "../../../../actions/device-type.actions";
import ValidationForm from "../../../../components/ValidationForm";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import SubmitButton from "../../../../components/SubmitButton";
import {Typeahead} from "react-bootstrap-typeahead";
import {deviceGroupActions} from "../../../../actions/device-group.actions";
import {Spinner} from "react-bootstrap";
import {userHelper} from "../../../../helpers/user-helper";

class NetworkDeviceForm extends Component {

    state = {
        form: {
            deviceTypeId: -1,
            deviceType: "",
            label: "",
            description: "",
            ipAddress: "",
            port: 0,
            mac: "",
            volumeManagement: false,
            diagnosticMode: false,
            deviceGroupIds: [],
            showOnDashboard: false,
            useScenario: false,
            details: false,
            tickOnlyOnExhibitionStateChange: false,
            retryTickCountOnExhibitionStateChange: 0,
        },
        isEdit: false,
        selectedList: []
    };

    componentDidMount() {
        const { dispatch, data } = this.props;
        dispatch(deviceTypeActions.getDropDownList());
        dispatch(deviceGroupActions.getDeviceGroupDropDownList());

        if(data) {
            this.setState({
                isEdit: true,
                form: {
                    id: data.id,
                    deviceTypeId: data.deviceTypeId,
                    deviceType: data.deviceType,
                    label: data.label,
                    description: data.description || "",
                    ipAddress: data.ipAddress,
                    port: data.port,
                    mac: data.mac || "",
                    volumeManagement: data.volumeManagement,
                    diagnosticMode: data.diagnosticMode,
                    deviceGroupIds: data.deviceGroupIds,
                    useScenario: data.useScenario,
                    showOnDashboard: data.showOnDashboard,
                    details: data.details,
                    tickOnlyOnExhibitionStateChange: data.tickOnlyOnExhibitionStateChange,
                    retryTickCountOnExhibitionStateChange: data.retryTickCountOnExhibitionStateChange | 0
                }
            })
        }
    }
D
    componentDidUpdate(prevProps, prevState, snapshot) {
        // set select dropdown
        if(prevProps.dropdownTypes !== this.props.dropdownTypes && this.props.dropdownTypes !== null) {

            const deviceTypeSelected = this.props.dropdownTypes.find(item => {
                if(this.state.form.deviceTypeId !== -1)
                    return item.id === this.state.form.deviceTypeId;
                else
                    return item.id === this.props.dropdownTypes[0].id
            });

            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    port: deviceTypeSelected.port,
                    deviceTypeId: deviceTypeSelected.id,
                    deviceType: deviceTypeSelected
                }
            });
        }

        // set device group
        if(prevProps.dropdownGroups !== this.props.dropdownGroups && this.props.dropdownGroups !== null)  {
            let selected = [];

            if(this.state.form.deviceGroupIds.length > 0) {
                this.state.form.deviceGroupIds.forEach((item) => {
                    selected.push(this.props.dropdownGroups.find((x) => x.id === item))
                })
            }

            this.setState({
                ...this.state,
                selectedList: selected
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleOnChangeCheckbox = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.checked
            }
        });
    };

    handleSelect = (e) => {
        e.preventDefault();
        const deviceTypeId = parseInt(e.target.value);

        const deviceTypeSelected = this.props.dropdownTypes.find(item => {
            return item.id === deviceTypeId
        });

        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                port: deviceTypeSelected.port,
                deviceType: deviceTypeSelected,
                [e.target.name] : deviceTypeId,
            }
        });
    };

    handleChangeDeviceGroups = (deviceGroupList) => {
        this.setState({
            ...this.state,
            selectedList: deviceGroupList,
            form: {
                ...this.state.form,
                deviceGroupIds: deviceGroupList.map((item) => {
                    return item.id
                })
            }
        })
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;

        if(this.state.isEdit)
            dispatch(networkDeviceActions.editDevice(this.state.form));
        else
            dispatch(networkDeviceActions.createDevice(this.state.form));
    };


    render() {
        const { t, dropdownTypes, dropdownGroups, validationForm, user } = this.props;
        const { form } = this.state;

        console.log(form);

        const useScenario = userHelper.getUseExhibitionScenario(user);

        const selectDom = dropdownTypes ? ( dropdownTypes?.map((item) => {
            return (
                <option key={item.id} value={item.id} data-port={item.port}> {item.label} </option>
            )
        })) : ( <option value={null}>Loading ...</option> );

        const deviceGroupSelect = dropdownGroups ? (
            <Typeahead
                id="network-device-groups"
                labelKey={option => {
                    return option.label || ""
                }}
                multiple
                required
                selected={this.state.selectedList}
                onChange={ (selected) => this.handleChangeDeviceGroups(selected) }
                options={dropdownGroups}
            />
        ) : (<div><Spinner animation={"border"} /></div>);


        return (
            <form onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="deviceType">{ t('type') }</label>
                            <select className="form-control" name="deviceTypeId" value={form.deviceTypeId} onChange={this.handleSelect}>
                                { !selectDom || selectDom }
                            </select>
                        </div>
                        <div className="form-group ">
                            <label className="col-form-label"> {t('label')} </label>
                            <input
                                type="text"
                                className={`form-control ${validationForm?.errorMessages['Label'] ? "is-invalid" : ''}`}
                                name="label"
                                value={form.label}
                                onChange={this.handleOnChangeInput}
                                required
                            />
                            <ValidationForm validationKey={validationForm?.errorMessages['Label']}/>
                        </div>

                        <div className="form-group">
                            <label className="col-form-label" > {t('ip-address')} </label>
                            <input
                                type="text"
                                className={`form-control ${validationForm?.errorMessages['IpAddress'] ? "is-invalid" : ''}`}
                                name="ipAddress"
                                minLength="7"
                                maxLength="15"
                                size="15"
                                pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$"
                                value={form.ipAddress}
                                onChange={this.handleOnChangeInput}
                                required
                            />
                            <ValidationForm validationKey={validationForm?.errorMessages['IpAddress']}/>
                        </div>
                        <div className="form-group">
                            <label className="col-form-label"> {t('port')} </label>
                            <input
                                type="number"
                                className="form-control"
                                name="port"
                                value={form.port}
                                onChange={this.handleOnChangeInput}/>
                        </div>
                        <div className="form-group ">
                            <label  className="col-form-label" > {t('mac')} </label>
                            <input
                                type="text"
                                className={`form-control ${validationForm?.errorMessages['Mac'] ? "is-invalid" : ''}`}
                                name="mac"
                                value={form.mac}
                                onChange={this.handleOnChangeInput}/>
                            <ValidationForm validationKey={validationForm?.errorMessages['Mac']}/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label className="col-form-label" > {t('description')} </label>
                            <textarea
                                className="form-control"
                                name="description"
                                title="Description"
                                value={form.description}
                                onChange={this.handleOnChangeInput}  />
                        </div>
                        <div className="form-group">
                            <label className="col-form-label"> {t('volume-management')} </label>
                            <input
                                type="checkbox"
                                className="form-check"
                                name="volumeManagement"
                                checked={form.volumeManagement}
                                onChange={this.handleOnChangeCheckbox} />
                        </div>
                        <div className="form-group">
                            <label className="col-form-label"> {t('diagnostic-mode')} </label>
                            <input
                                type="checkbox"
                                className="form-check"
                                name="diagnosticMode"
                                checked={form.diagnosticMode}
                                onChange={this.handleOnChangeCheckbox} />
                        </div>

                        <hr/>

                        { form.deviceType?.label?.toLowerCase().includes("lantick") ? (
                            <React.Fragment>
                                <div className="form-group">
                                    <label className="col-form-label"> { t('show-in-dashboard') } </label>
                                    <input
                                        type="checkbox"
                                        className="form-check"
                                        name="showOnDashboard"
                                        checked={form.showOnDashboard}
                                        onChange={this.handleOnChangeCheckbox}
                                    />
                                </div>
                                <hr/>
                            </React.Fragment>
                        ) : (
                            <React.Fragment/>
                        )  }

                        { form.deviceType?.label?.toLowerCase().includes("pjlink") ? (
                            <React.Fragment>
                                <div className="form-group">
                                    <label className="col-form-label"> { t('get-details') } </label>
                                    <input
                                        type="checkbox"
                                        className="form-check"
                                        name="details"
                                        checked={form.details}
                                        onChange={this.handleOnChangeCheckbox}
                                    />
                                </div>
                                <hr/>
                            </React.Fragment>
                        ) : (
                            <React.Fragment/>
                        )  }

                        <React.Fragment>
                            <div className="form-group">
                                <label className="col-form-label"> {t('tick-only-change-state')} </label>
                                <input
                                    type="checkbox"
                                    className="form-check"
                                    name="tickOnlyOnExhibitionStateChange"
                                    checked={form.tickOnlyOnExhibitionStateChange}
                                    onChange={this.handleOnChangeCheckbox}
                                />
                            </div>
                        </React.Fragment>

                        { form.tickOnlyOnExhibitionStateChange ? (
                            <React.Fragment>
                                <div className="form-group">
                                    <label className="col-form-label"> {t('retry-count')} </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="retryTickCountOnExhibitionStateChange"
                                        value={form.retryTickCountOnExhibitionStateChange}
                                        onChange={this.handleOnChangeInput}/>
                                </div>
                            </React.Fragment>
                        ) : (<React.Fragment/>) }

                        <hr/>

                        { !useScenario || (
                            <div className="form-group">
                                <label className="col-form-label"> { t('use-scenario') } </label>
                                <input
                                    type="checkbox"
                                    className="form-check"
                                    name="useScenario"
                                    checked={form.useScenario}
                                    onChange={this.handleOnChangeCheckbox}
                                />
                            </div>
                        ) }

                        <div className="form-group">
                            <div className="form-group">
                                <label className="col-form-label">{t('device-group')}</label>
                                { deviceGroupSelect }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mt-4 form-group">
                            <SubmitButton type={this.state.isEdit} />
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}
const mapStateToProps = (state) => {
    const { dropdown: dropdownTypes } = state.deviceTypeReducer;
    const { dropdown: dropdownGroups } = state.deviceGroupReducer;
    const { validationForm } = state.networkDeviceReducer;
    const { user } = state.authenticationReducer;
    return {
        dropdownTypes,
        dropdownGroups,
        validationForm,
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(NetworkDeviceForm));
